import { gql } from 'graphql-tag'

export const FRAGMENT_QUOTE_ERROR_GENERAL = gql`
  fragment ServiceErrorItems on ServiceError {
    error
  }
`
